import React from 'react';
import {
  // Métier / produits
  Cow, ForkKnife, Pepper, Tree, Fire, Thermometer, Drop, Snowflake,
  Fish, Bone, BowlFood, Jar, Hamburger, Knife, Scissors,
  // Inventaire / commande / hub
  Package, Tag, ShoppingCart, Truck, Storefront, Barcode, Ticket,
  // Argent
  CurrencyDollar, Receipt, ChartBar, ChartLine, Wallet, Bank,
  // Docs / contact
  FileText, ClipboardText, LinkSimple, Camera, Calendar, Clock,
  MapPin, Phone, EnvelopeSimple, ChatCircle,
  // Statuts
  CheckCircle, Check, Warning, WarningCircle, Info, XCircle, Lock,
  // Actions UI
  Plus, Trash, PencilSimple, Eye, MagnifyingGlass, ArrowsClockwise,
  DownloadSimple, UploadSimple, FloppyDisk, X, ArrowUUpLeft,
  ArrowRight, CaretRight, ArrowCounterClockwise,
  // Navigation
  House, Gear, Envelope, Bell, User, UserCircle, Buildings, Lightbulb,
  Heart, Star, Confetti,
} from '@phosphor-icons/react';

// Mapping nom métier → composant Phosphor (public-form).
// Aligné avec l'app interne — clés partagées + extensions pour le hub/landing.
const MAP = {
  // ── Produits Escamel ──
  viande:        Cow,
  saumon:        Fish,
  ribs:          Bone,
  cotes_levees:  Bone,
  porc:          BowlFood,
  saucisse:      Hamburger,
  saucisses:     Hamburger,
  sauce:         Jar,
  brisket:       Cow,
  burnt_ends:    Fire,
  repas:         ForkKnife,
  epices:        Pepper,
  legume:        Pepper,
  laitier:       Drop,
  bois:          Tree,
  fumage:        Fire,
  temperature:   Thermometer,
  congelation:   Snowflake,
  decoupe:       Knife,
  parage:        Scissors,
  // ── Commande / hub ──
  package:       Package,
  emballage:     Package,
  etiquette:     Tag,
  panier:        ShoppingCart,
  transport:     Truck,
  boutique:      Storefront,
  sku:           Barcode,
  billet:        Ticket,
  // ── Argent ──
  argent:        CurrencyDollar,
  recu:          Receipt,
  facture:       Receipt,
  analytics:     ChartBar,
  courbe:        ChartLine,
  encaisse:      Wallet,
  banque:        Bank,
  // ── Docs / contact ──
  document:      FileText,
  liste:         ClipboardText,
  lien:          LinkSimple,
  photo:         Camera,
  date:          Calendar,
  heure:         Clock,
  lieu:          MapPin,
  telephone:     Phone,
  email:         EnvelopeSimple,
  message:       ChatCircle,
  // ── Statuts ──
  succes:        CheckCircle,
  check:         Check,
  attention:     Warning,
  alerte:        WarningCircle,
  info:          Info,
  erreur:        XCircle,
  verrou:        Lock,
  idee:          Lightbulb,
  // ── Actions UI ──
  ajouter:       Plus,
  supprimer:     Trash,
  modifier:      PencilSimple,
  voir:          Eye,
  recherche:     MagnifyingGlass,
  rafraichir:    ArrowsClockwise,
  recalculer:    ArrowCounterClockwise,
  telecharger:   DownloadSimple,
  televerser:    UploadSimple,
  sauvegarder:   FloppyDisk,
  fermer:        X,
  retour:        ArrowUUpLeft,
  fleche:        ArrowRight,
  chevron:       CaretRight,
  // ── Navigation / brand ──
  accueil:       House,
  parametres:    Gear,
  envelope:      Envelope,
  notification:  Bell,
  utilisateur:   User,
  compte:        UserCircle,
  entreprise:    Buildings,
  coeur:         Heart,
  etoile:        Star,
  confetti:      Confetti,
};

/**
 * <Icon name="viande" /> — icône SVG cohérente (remplace les emojis).
 * @param name   clé métier (voir MAP)
 * @param size   px (défaut 18)
 * @param weight thin|light|regular|bold|fill|duotone (défaut regular)
 * @param color  couleur (défaut: currentColor → hérite du texte)
 */
export default function Icon({ name, size = 18, weight = 'regular', color = 'currentColor', ...rest }) {
  const Cmp = MAP[name];
  if (!Cmp) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`[Icon] nom inconnu : "${name}" — ajoute-le dans Icon.jsx MAP`);
    }
    return <WarningCircle size={size} weight={weight} color={color} {...rest} />;
  }
  return <Cmp size={size} weight={weight} color={color} {...rest} />;
}

export const ICON_NAMES = Object.keys(MAP);
